module.exports = __webpack_public_path__ + "img/sign-in.9033f707.svg";